// Calls a Firebase callable, loading the Functions SDK on demand instead of at module scope.
//
// WHY: any module that does `import { httpsCallable } from 'firebase/functions'` at the top
// level pulls the ~490 KB firebase chunk into the EAGER import graph. Vite then emits a
// <link rel="modulepreload"> for it, so the browser fetches and parses the whole SDK before
// the hero can paint — even though nothing above the fold needs Firebase. Every callable in
// this app runs inside a useEffect (i.e. after first paint), so the SDK can safely arrive late.
//
// Keeping this helper the ONLY entry point is what keeps that chunk off the critical path:
// a single static `firebase/functions` import in any eagerly-routed module puts it right back.
// Lazily-routed modules (React.lazy in main.tsx) are already off the critical path and may
// keep importing the SDK directly.
export async function callable<Req, Res>(name: string, payload: Req): Promise<{ data: Res }> {
  const [{ httpsCallable }, { functions }] = await Promise.all([
    import('firebase/functions'),
    import('./firebase'),
  ]);
  return httpsCallable<Req, Res>(functions(), name)(payload);
}
